import $ from 'jquery'
import noUiSlider from "nouislider";
import 'select2';

export default {
    init() {
        // JavaScript to be fired on the home page
    },
    finalize() {

      var lang = $('html').attr('lang');

      $('#vrsta-kredita').select2();

      function addSeparator(num, lang) {
        var separator;
        if(lang === 'ru_RU') separator = ' ';
        else separator = ',';
        var str = "";
        var count = 0;
        for(var i = num.length; i > 3; i-= 3, count++){
          str = separator +num.substr(i-3, 3) + str;
        }
        str = num.substr(0, num.length - 3*count) + str;
        return str;
      }

      function addSeparatorsNumber(num, lang) {
        if(num.indexOf('.') === -1) num += '.00';
        var arr = num.toString().split('.');
        var str = "";
        if(arr.length === 2){
          str = addSeparator(arr[0], lang);
          str += '.' + arr[1];
        }
        return str;
      }

      function PMT(rate, nperiod, pv, fv, type) {
        if (!fv) fv = 0;
        if (!type) type = 0;

        if (rate == 0) return -(pv + fv)/nperiod;

        var pvif = Math.pow(1 + rate, nperiod);
        var pmt = rate / (pvif - 1) * -(pv * pvif + fv);

        if (type == 1) {
            pmt /= (1 + rate);
        }
        return pmt;
      }

      var iznos_kredita,
        period,
        zarada,
        kamatna_stopa,
        osiguranje = 1;

      kamatna_stopa = $("#vrsta-kredita").children("option:selected").val();
      $("#vrsta-kredita").change(function(){
        kamatna_stopa = $(this).children("option:selected").val();
        $('#tabela').html('');
      });

      iznos_kredita = $("#iznos").val();
      $("#iznos").on("change paste keyup", function(){
        iznos_kredita = $(this).val();
      });

      period = $("#rok-otplate").val();
      $("#rok-otplate").on("change paste keyup", function(){
        period = $(this).val();
      });

      $(".izracunaj").on("click", function(e){
        e.preventDefault();
        izracunaj();
      });

      function izracunaj(){
        var ucesce = (0.2 * iznos_kredita).toString();
        var iznos_kredita_bez_ucesca = (iznos_kredita - ucesce).toString();        
        var koeficijent_za_obracun_rate = (kamatna_stopa / 100) / 12;
        var mesecni_anuitet = (-PMT(koeficijent_za_obracun_rate , period  , iznos_kredita_bez_ucesca)).toFixed(2);

        var ukupanBrDana = new Array();
        var mesecBrDana = new Array();

        $('.iznos-kredita').html(addSeparatorsNumber(iznos_kredita_bez_ucesca, lang));
        $('.kamatna-stopa').html(kamatna_stopa);
        $('.period').html(period);
        $('.anuitet').html(addSeparatorsNumber(mesecni_anuitet, lang));
    
        var redni_broj = (lang === "sr-RS") ? "Redni broj" : (lang === "en-US")  ? "Ordinal number" : "Порядковый номер";
        var ostatak_duga = (lang === "sr-RS") ? "Ostatak duga" : (lang === "en-US") ? "The rest of the debt" : "Остаток долга";
        var glavnica = (lang === "sr-RS") ? "Glavnica" : (lang === "en-US") ? "Principal" : "Основная сумма кредита";
        var kamata = (lang === "sr-RS") ? "Kamata" : (lang === "en-US") ? "Interest" : "Проценты по кредиту";
        var anuitet = (lang === "sr-RS") ? "Anuitet" : (lang === "en-US") ? "Annuity" : "Аннуитет";
        var tabela = '';
         
        tabela += '<table width="100%">';
        tabela += '<tr>';
        tabela += '<th>' + redni_broj + '</th>';
        tabela += '<th>' + ostatak_duga  + '</th>';
        tabela += '<th>' + glavnica + '</th>';
        tabela += '<th>' + kamata + '</th>';
        tabela += '<th>' + anuitet + '</th>';
        tabela += '</tr>';
        
        var periodLoop = parseInt(period) + 1;
        var ostatak_duga;
        var ostatak = parseInt(iznos_kredita_bez_ucesca);

        for (var j = 1; j < periodLoop; j++) {
          var uplata_kamate = koeficijent_za_obracun_rate * ostatak;
          var uplata_glavnice = mesecni_anuitet - uplata_kamate;

            ostatak = ostatak - uplata_glavnice;

            if ( j == 1) {
              ostatak_duga = parseInt(iznos_kredita_bez_ucesca);
            }else{
              ostatak_duga = ostatak + uplata_glavnice;
            }

          tabela += '<tr>';
          tabela += '<td>'+j+'</td>';
          tabela += '<td>'+(ostatak_duga).toFixed(2)+'</td>';
          tabela += '<td>'+(uplata_glavnice).toFixed(2)+'</td>';
          tabela += '<td>'+(uplata_kamate).toFixed(2)+'</td>';
          tabela += '<td id="anu_'+j+'">'+mesecni_anuitet+'</td>';
          tabela += '</tr>';
        };

        tabela += '</table>';

        $("#tabela").html(tabela);
      }

    }

};



// WEBPACK FOOTER //
// ./scripts/routes/pageTemplateStambeniKredit.js